import React from "react";
import { Address, IDoctor } from "../dto/interfaces";
import { getGoogleMapsEmbedUrl } from "../utils/mapUtils";

interface MapEmbedProps {
    url: string;
    className?: string; // Allow custom styling
}

/**
 * A simple, reusable component that renders an
 * interactive Google Map iframe for a given address.
 */
const MapEmbed: React.FC<MapEmbedProps> = ({ url, className = "" }) => {
    return (
        <iframe
            src={url}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Clinic Location Map"
            className={className}
        />
    );
};

export default MapEmbed;
